import React, { Fragment, FC, useContext, useEffect, useState } from "react";
import { Dialog, Transition } from '@headlessui/react';

import { Link, useNavigate, useParams } from "react-router-dom";
import Badge from "./Badge";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Label from "components/Label/Label";
import Input from "shared/Input/Input";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import { PhoneInput } from "react-international-phone";
import Button from "components_common/Button/Button";

import { ArrowSmallLeftIcon, PhotoIcon } from "@heroicons/react/24/outline";
import DaumPostcode from 'react-daum-postcode';
import { requestAPI } from "utils/api";

import { GlobalDataContext } from "contexts/GlobalData";

import PassportImg from '../../assets/images/passport-sample.png';
import LicenseFrontImg from '../../assets/images/license-front.png';
import LicenseBackImg from '../../assets/images/license-back.png';
import { UIContext } from "contexts/UIContext";

const PictureUpload = ({
	type,
	productId,
	travelerNo,
	label,
	url,
	//setNewPassportUrl
	etcfiles=[],
	update=()=>{},
}: any) => {

	const { id, idx } = useParams ();
	const navigate = useNavigate ();

	const {
		toast,
		modal,
	} = useContext(UIContext);  

	const { 
		initData,
	} = useContext (GlobalDataContext);

	// useEffect(()=>{

	// },[etcfiles]);

	const [ uploading, setUploading ] = useState <boolean> (false);
	const [ uploadedInfo, setUploadedInfo ] = useState <any> ({});
	const [ postImg, setPostImg ] = useState([]);
	const [ previewImg, setPreviewImg ] = useState("");
	const [ imgData, setImgData ] = useState<any>(null);
	const [ imgUrl, setImgUrl ] = useState <any> (url);
	const [ newFileName, setNewFileName ] = useState <any> ("");

	const [ filenameObj, setFilenameObj ] = useState <any> ({
		originName: "",
		newName: ""
	});

	const typeInfo = () => {
		if (type === "passport") {
			return {
				coverImg: PassportImg,
				textExists: "여권 정보가 존재해요, 이미지는 비공개 저장되며 보여주지 않아요!",
				textResend: "여권 재전송"
			}
		} else if (type === "license_front") {
			return {
				coverImg: LicenseFrontImg,
				textExists: "운전면허 (앞면) 정보가 존재해요, 이미지는 비공개 저장되며 보여주지 않아요!",
				textResend: "운전면허 (앞면) 재전송"
			}
		} else if (type === "license_back") {
			return {
				coverImg: LicenseBackImg,
				textExists: "운전면허 (뒷면) 정보가 존재해요, 이미지는 비공개 저장되며 보여주지 않아요!",
				textResend: "운전면허 (뒷면) 재전송"
			}
		}
	}

	// const coverImgUrl = () => {
	// 	if (type === "passport") {
	// 		return PassportImg;
	// 	} else if (type === "license_front") {
	// 		return LicenseFrontImg;
	// 	} else if (type === "license_back") {
	// 		return LicenseBackImg;
	// 	}
	// }

	const text1 = () => {
		if (type === "passport") {
			return "여권 정보가 존재해요, 이미지는 비공개 저장되며 보여주지 않아요!";
		} else if (type === "license_front") {
			return "";
		} else if (type === "license_back") {
			return "운전면허 (뒷면) 정보가 존재해요, 이미지는 비공개 저장되며 보여주지 않아요!";
		}
	}

	//let _newFileName = "";

	useEffect(()=>{
		setImgUrl(url);
	},[url])

	const tempUploadRequest = async (_imgData: any) => {
		const _initData = {...initData};
		const _id = _initData.userInfo._id;

		const formData = new FormData();

		const file = _imgData.name.split('.');
		const now = Number(new Date());
		
		let _filenameObj: any = {};

		let _newFileName = `${_id}_${travelerNo}_${type}.${file[file.length-1]}`;
		let compareFileName = `${file[0]}.${file[file.length-1]}`;
		
		// 컴포넌트 호출부가 etcupload일때 멀티파일 업로드 구분을 위해 파일 이름 구분
		if (type === "etcupload") {
			let rndId =  Number(new Date()).toString(); 
			rndId = rndId.slice(-5, rndId.length);
			
			_filenameObj = {
				originName: compareFileName,
				newName: `${_id}_${travelerNo}_${type}_${rndId}.${file[file.length-1]}`
			};

			_newFileName = _filenameObj.newName;
		}

		


        formData.append("file", _imgData, _newFileName);

		setNewFileName(_newFileName);
		setFilenameObj(_filenameObj);
        
		const res_upload: any = await requestAPI ('FILE', `upload`, formData);

		if (res_upload.code === 1000) {
			//setNewPassportUrl(newFileName);
			setUploading(false);
		} else {
			//실패 처리
		}
	};
	
	const clearImg = () => {
		setUploadedInfo ({});
		setPostImg ([]);
		setPreviewImg ("");
		setImgUrl (url);
	};
	

	const setFileInfo = (file: any) => {
		const { name, size: byteSize, type } = file;
		const size = (byteSize / (1024 * 1024)).toFixed(2) + 'mb';
		
		setUploadedInfo({ name, size, type }); // name, size, type 정보를 uploadedInfo에 저장
	};
	


	const handleDelete = () => {
		setImgUrl("");
	}

	const fileUpload_passport = async () => {
		const res_cp: any = await requestAPI ('FILE-CP', `passport-cp`, {
			productId,
			travelerNo,
			passportUrl: newFileName
		});

		if (res_cp.code === 1000) {
			const res_info: any = await requestAPI ('PUT', `v1/reserve/${id}/traveler-passport/${idx}`, {
				passportUrl: `${productId}/${newFileName}`
			});

			if (res_info.code === 1000) {
				navigate(0)	
			}
		} else {
			console.log('오류');
		}
	}

	const fileUpload_license_front = async () => {
		const res_cp: any = await requestAPI ('FILE-CP', `license-front-cp`, {
			productId,
			travelerNo,
			url: newFileName
		});

		if (res_cp.code === 1000) {
			const res_info: any = await requestAPI ('PUT', `v1/reserve/${id}/traveler-license/${idx}`, {
				field: "licenseUrl",
				url: `${productId}/${newFileName}`
			});

			if (res_info.code === 1000) {
				//update(res_info.data.info);
				navigate(0);
			}
		} else {
			console.log('오류');
		}
	}

	const fileUpload_license_back = async () => {
		const res_cp: any = await requestAPI ('FILE-CP', `license-back-cp`, {
			productId,
			travelerNo,
			url: newFileName
		});

		if (res_cp.code === 1000) {
			const res_info: any = await requestAPI ('PUT', `v1/reserve/${id}/traveler-license/${idx}`, {
				field: "licenseUrl2",
				url: `${productId}/${newFileName}`
			});

			if (res_info.code === 1000) {
				navigate(0);
			}
		} else {
			console.log('오류');
		}
	}

	const fileUpload_etc = async () => {
		//productId === reserve _id
		const res_cp: any = await requestAPI ('FILE-CP', `etcfiles-cp`, {
			productId,
			travelerNo,
			url: newFileName
		});
		// console.log(res_cp)
		// console.log(`${productId}/${newFileName}`);

		if (res_cp.code === 1000) {
			const res_info: any = await requestAPI ('PUT', `v1/reserve/${id}/traveler-etcfiles/${idx}`, {
				//field: "licenseUrl2",
				url: `${productId}/${newFileName}`,
				productId,
				filenameObj: {
					originName: filenameObj.originName,
					newName: `${productId}/${filenameObj.newName}`
				}

			});

			if (res_info.code === 1000) {
				navigate(0);
			}
		} else {
			console.log('오류');
		}
	}

	const handleConfirm = async () => {

		if (type === "passport") {
			fileUpload_passport ();	
		} else if (type === "license_front") {
			fileUpload_license_front ();	
		} else if (type === "license_back") {
			fileUpload_license_back ();	
		} else {
			fileUpload_etc ();
		}
	}

	const onChangeFile = (e : any) => {

		setUploading(true);

		let fileArr = e.target.files;
		let fileRead: any = new FileReader();

		setPostImg(Array.from(fileArr));
		setFileInfo(fileArr[0]);
    	
		fileRead.onload = async () => {
			setPreviewImg(fileRead.result);
		};
		
		fileRead.readAsDataURL(fileArr[0]);

		//setImgData (fileArr[0]);
		
		tempUploadRequest (fileArr[0]);
	};



	return (
		<>
			<div className="mt-5">
				<Label className="text-[1.1rem]">{label}</Label>
				
				<div>
					{imgUrl !== ""
					?
						<div className="flex items-center">
							<div> 
								<img 
									className={"w-[170px]"}
									src={typeInfo()?.coverImg} 
								/>
							</div>
							<div className="ml-4">
								<div>
									{imgUrl === ""
										? ""
										: <span className="text-[0.9rem] text-green-700">{typeInfo()?.textExists}</span> }
								</div>				
								<div className="mt-5">
									<Button
										className={`ttnc-ButtonPrimary disabled:bg-opacity-70 bg-red-600 hover:bg-red-700 text-white !pl-4 !pr-4 !pt-1 !pb-1`}
										onClick={() => {handleDelete()}}			
									>
										{typeInfo()?.textResend}
									</Button>
								</div>
							</div>
							
						</div>
						
					:
						Object.keys(uploadedInfo).length === 0
						? 
							<div className={`flex justify-center items-end w-full`}>
								<div className="w-full">
									<div className="mt-2 flex justify-center rounded-lg border border-dashed border-gray-900/25 px-6 py-10">
										<div className="text-center">
											<PhotoIcon aria-hidden="true" className="mx-auto h-12 w-12 text-gray-300" />
											<div className="mt-4 text-sm leading-6 text-gray-600">
												<label
													htmlFor="test"
													className="relative cursor-pointer rounded-md bg-white font-semibold text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-600 focus-within:ring-offset-2 hover:text-indigo-500"
													
												>
													<span>파일선택</span>
													<input 
														id="test" 
														name="attachment" 
														type="file" 
														className="sr-only"
														onChange={onChangeFile}
														
													/>
												</label>
											</div>
											<p className="text-xs leading-5 text-gray-600">PNG, JPG, GIF up to 10MB</p>
										</div>
									</div>
								</div>
							</div>
						: 
							<div className="w-full">
								<div className="flex items-center justify-center">
									<img src={previewImg} className="object-cover h-[300px]" />
								</div>
								<div className="flex flex-col mt-12 space-y-5 sm:space-y-0 sm:space-x-3 sm:flex-row justify-end">
									
									<ButtonPrimary
										onClick={() => clearImg()}
									>
										취소
									</ButtonPrimary>

									<ButtonPrimary
										loading={uploading}
										onClick={() => handleConfirm()}
									>
										저장
									</ButtonPrimary>
								</div>				
							</div>		
					}
				</div>
			</div>
				
		</>
	);
};

export default PictureUpload;
